import { useState } from "react";
import ConvertPopup from "./ConvertModel";
import Modal from "./layout";
import UploadFileModel from "./uploadFileModel";
import DownloadAlertModal from "./downloadAlert";
import LoginModal from "./loginmodal";
import SignupModal from "./signupmodal";
import ForgetPasswordModal from "./forgetpasswordmodal";
import EmailSentModal from "./emailsentmodal";
import ResetPasswordModal from "./resetpasswordmodal";
import CongratulationModal from "./congratulationmodal";
import OTPVerifyModal from "./otpverifymodel";
import UpgradePlanModal from "./upgradePlanModal";
import SidePanel from "../SidePanel";
import { AUTH_STATES } from '../../constants/routes';
import LinkAccountModal from "./linkAccountModal";

const Popups = ({
  show,
  hide,
  state,
  setstate,
  PDFUI,
  type,
  initial,
  setInitial,
  className,
  startOver,
}) => {
  const [email, setEmail] = useState("");

  // Define which states should use SidePanel
  const sidePanelStates = [1, 2, 5, 6, 7, 8, 10, 12, 13];
  const useSidePanel = sidePanelStates.includes(state);

  return (
    <>
      {!useSidePanel && (
        <Modal show={show} hide={hide} className={`${className} my-16 mx-4`}>
          {(() => {
            switch (state) {
              case 3: {
                return (
                  <UploadFileModel
                    setstate={setstate}
                    initial={initial}
                    setInitial={setInitial}
                    PDFUI={PDFUI}
                    type={type}
                  />
                );
              }
              case 4: {
                return <ConvertPopup setstate1={setstate} PDFUI={PDFUI} />;
              }
              case 9: {
                return (
                  <DownloadAlertModal
                    setstate1={setstate}
                    PDFUI={PDFUI}
                    setPopup={hide}
                  />
                );
              }
              case 11: {
                return (
                  <UpgradePlanModal
                    setstate1={setstate}
                    setPopup={hide}
                    title="It's time to upgrade."
                    message="You've reached limit of your current plan, To add another set, you need to choose a higher plan."
                  />
                );
              }
              default:
                return null;
            }
          })()}
        </Modal>
      )}

      <SidePanel hide={hide} show={useSidePanel && show} startOver={startOver}>
        {(() => {
          switch (state) {
            case AUTH_STATES.LOGIN: {
              return <LoginModal setstate1={setstate} setPopup={hide} />;
            }
            case AUTH_STATES.SIGNUP: {
              return <SignupModal setstate1={setstate} setPopup={hide} />;
            }
            case AUTH_STATES.FORGOT_PASSWORD: {
              return (
                <ForgetPasswordModal setEmail={setEmail} setstate1={setstate} />
              );
            }
            case AUTH_STATES.EMAIL_SENT: {
              return <EmailSentModal setstate1={setstate} />;
            }
            case AUTH_STATES.RESET_PASSWORD: {
              return <ResetPasswordModal email={email} setstate1={setstate} />;
            }
            case AUTH_STATES.CONGRATULATION: {
              return <CongratulationModal setstate1={setstate} />;
            }
            case AUTH_STATES.OTP_VERIFY: {
              return <OTPVerifyModal setstate1={setstate} email={email} />;
            }
            case AUTH_STATES.LINK_ACCOUNT: {
              return <LinkAccountModal 
                setstate1={setstate} 
                email={localStorage.getItem("linkAccountEmail")}
                provider={localStorage.getItem("linkAccountProvider")}
              />;
            }
            case AUTH_STATES.VERIFY_EMAIL: {
              return <OTPVerifyModal 
                setstate1={setstate} 
                email={localStorage.getItem("verifyEmail")} 
              />;
            }
            default:
              return null;
          }
        })()}
      </SidePanel>
    </>
  );
};

export default Popups;
